import React, { useCallback } from 'react';
import { withStyles } from 'tss-react/mui';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import EducatorSidebar from './EducatorSidebar';
import ManageResponses from './ManageResponses';

const styles = theme => ({
  containerLeftSpacing: {
    paddingRight: theme.typography.pxToRem(26),
  },
  containerRightSpacing: {
    paddingLeft: theme.typography.pxToRem(26),
  },
  responseFormPadding: {
    padding: theme.typography.pxToRem(25),
  },
});

const EducatorProfiles = ({ classes, handleSupervisorChange, supervisor, user, routeProfileId, responseLabels }) => {
  const [refreshTick, setRefreshTick] = React.useState(0);
  const [selectedProfile, setSelectedProfile] = React.useState(null);
  const [selectedProfileIdState, setSelectedProfileIdState] = React.useState(null);

  const forceRefresh = () => {
    setRefreshTick(Date.now());
  };

  const setProfile = (profile) => {
    setSelectedProfile(profile);
    setSelectedProfileIdState(profile.id);
  };

  const profileCheck = useCallback((selectedProfile) => {
    if (selectedProfile === null) {
      return (<div>Loading...</div>)
    }
    else if (selectedProfile === 'none') {
      return (<div>No profiles available</div>)
    }
    else {
      return ( <ManageResponses
        profile={selectedProfile}
        onForceRefresh={forceRefresh}
        responseLabels={responseLabels}
        supervisor={supervisor}
        user={user} />
      );
    }
  },[selectedProfile, forceRefresh, responseLabels, supervisor, user]);

  return (
    <Grid container>
      <Grid className={classes.containerLeftSpacing} size={4}>
        <Paper>
          <EducatorSidebar
            handleSupervisorChange={handleSupervisorChange}
            supervisor={supervisor}
            user={user}
            onProfileSelected={setProfile}
            refreshTick={refreshTick}
            selectedItem={selectedProfileIdState}
            routeProfileId={routeProfileId}
          />
        </Paper>
      </Grid>
      <Grid className={classes.containerRightSpacing} size={8}>
        <Paper className={classes.responseFormPadding}>
          {profileCheck(selectedProfile)}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withStyles(EducatorProfiles, styles, { withTheme: true });
